import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  id: string;
  className?: string;
  children: React.ReactNode;
  containerClass?: string;
}
export function Section({
  id,
  className = '',
  children,
  containerClass = ''
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 relative ${className}`} data-id="element-182">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20 ${containerClass}`} data-id="element-183">
        {children}
      </motion.div>
    </section>;
}